<template>
  <!-- SEARCH FIELDS -->
   <div class="section">
      <CustomButton @click="randomConvict" :buttonTitle="'CHOOSE ANY CONVICT'" :buttonIcon="'search'" :buttonColour="'red'"></CustomButton>
      <h2>OR</h2>
      <!-- <p>ENTER INFORMATION INTO ANY OF THE<br>FIELDS BELOW TO NARROW YOUR RESULTS</p> -->
      <p>CHOOSE A RANDOM CONVICT BASED ON<br>ONE OR MORE OF THE FIELDS BELOW</p>
        <div style="padding: 1em 0;">
        <div class="nameSearch">
          <dropdown name="gName" placeholder="First Name" @selected="setGivenName"  :options="givenNamesC.length ? givenNamesC : givenNames" maxItems="0" style="z-index: 26;"></dropdown>
          <dropdown name="fName" placeholder="Last Name"  @selected="setFamilyName" :options="familyNameC.length ? familyNameC : familyName" maxItems="0" :startsWith=true style="z-index: 28;"></dropdown>
        </div>
        <div style="display: flex;">
          <dropdown name="country" placeholder="Country" @selected="setCountry" :options="countriesC.length ? countriesC : countries" maxItems="0" style="z-index: 24; flex: 3;"></dropdown>
          <dropdown name="gender"  placeholder="Gender"  @selected="setGender"  :options="gendersC.length ? gendersC : genders" noKeyboard   maxItems="0" style="z-index: 22;flex: 2;"></dropdown>
          <dropdown name="age"     placeholder="Age"     @selected="setAge"     :options="agesC.length ? agesC : ages"      maxItems="0" style="z-index: 20;flex: 2;"></dropdown>
        </div>
        <div class="nameSearch">
          <dropdown name="trade" placeholder="Trade" @selected="setTrade" :options="tradesC" maxItems="0" style="z-index: 18;"></dropdown>
          <dropdown name="crime" placeholder="Crime" @selected="setCrime" :options="crimesC" maxItems="0" style="z-index: 16;"></dropdown>
        </div>
      </div>
      <CustomButton @click="randomConvict" :buttonTitle="'CHOOSE NOW'" :buttonIcon="'search'" :buttonColour="'red'"></CustomButton>
    </div>
  <div class="searchPanel">
   
    <div class="searchOverlay" :style="'visibility:'+overlayState+';'" >
      <h2>{{ overlayText }}</h2>
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-bar-filling" :style="progressAnimation"></div>
        </div>
      </div>
    </div>
  </div>
  <!-- RESULTS -->
  <div v-if="conIndex > maxResults || !fieldSelected">
    <div style="display: flex; justify-content: center; margin-bottom: 0.75em;" class="searchResults">
      <h3 style="color: var(--grey); margin-right: -0.25em;">Search Results : &nbsp;</h3>
      <h3 v-if="randomCons.length == 0"> {{ possCount }} Match<span v-if="possCount != 1">es</span></h3>
      <h3 v-else>{{ randomCons.length }} Matches</h3>
    </div>

    <Footer :cantFindBtn="false" :backBtn="false"></Footer>
  </div>
</template>

<script>
import flags from '@/mixins/flags.js'
import fields from '@/mixins/fields.js'
import Dropdown from '@/components/DropDown.vue'
import HeaderBar from "@/components/HeaderBar.vue";
import Footer from "@/components/Footer.vue";
import EntryCompact from "@/components/EntryCompact.vue";
import CustomButton from "@/components/CustomButton.vue";

export default {
  name: "SearchView",
  mixins: [flags,fields],
  components: {
    Dropdown,
    HeaderBar,
    Footer,
    EntryCompact,
    CustomButton,
  },
  data() {
    return {
      maxResults: 1000,
      maxCons:1000,
      gName: null,
      fName: null,
      country: null,
      age: null,
      gender: null,
      ship: null,
      trade: null,
      year: null,
      crime: null,
      
      allNames:[],
      possCount: 0,
      possCons:[],
      randomCons:[],
      givenNamesAll:null,
      familyNamesAll:null,
      gendersAll:null,
      shipsAll:null,
      yearsAll:null,
      tradesAll:null,
      crimesAll:null,
      conIndex: 0,
      progressMax: 75000,
      optionsShown:false,
      overlayText:"Loading...",
      overlayState:"hidden",
      isSorted:false,
      allFields:["gName","fName","country"],
      activeFIelds:[],
    }
  },
  
  mounted() {
    const inited = this.$store.getters.getDataInitDone
    if (inited) {
      // Seed from cached store data without showing DB access overlay
      const cache = this.$store.getters.getFieldsCache || {}
      const clone = (arr)=> Array.isArray(arr) ? arr.concat([]) : []
      this.allNames = clone(this.$store.getters.getAllCons)
      // Basic lists
      this.givenNames = clone(cache.givenNamesAll)
      this.givenNamesC = clone(cache.givenNamesAllC)
      this.familyName = clone(cache.familyNamesAll || cache.familyNameAll)
      this.familyNameC = clone(cache.familyNameAllC)
      this.countries = clone(cache.countriesAll)
      this.countriesC = clone(cache.countriesAllC)
      this.genders = clone(cache.gendersAll)
      this.gendersC = clone(cache.gendersAllC)
      this.ages = clone(cache.agesAll)
      this.agesC = clone(cache.agesAllC)
      this.ships = clone(cache.shipsAll)
      this.shipsC = clone(cache.shipsAllC)
      this.years = clone(cache.yearsAll)
      this.yearsC = clone(cache.yearsAllC)
      this.trades = clone(cache.tradesAll)
      this.tradesC = clone(cache.tradesAllC)
      this.crimes = clone(cache.crimesAll)
      this.crimesC = clone(cache.crimesAllC)
      // Gender buckets
      this.maleCons = clone(cache.maleCons)
      this.femaleCons = clone(cache.femaleCons)
      this.unknownCons = clone(cache.unknownCons)
      this.maleGiven = clone(cache.maleGiven)
      this.maleGivenC = clone(cache.maleGivenC)
      this.femaleGiven = clone(cache.femaleGiven)
      this.femaleGivenC = clone(cache.femaleGivenC)
      this.maleFamily = clone(cache.maleFamily)
      this.maleFamilyC = clone(cache.maleFamilyC)
      this.femaleFamily = clone(cache.femaleFamily)
      this.femaleFamilyC = clone(cache.femaleFamilyC)
      // Keep overlay hidden on subsequent visits
      this.overlayState = "hidden"
    } else {
      // First app load: show DB access overlay and build caches
      this.overlayState = "visible"
      this.overlayText = "Accessing Database..."
      setTimeout(this.setUpData, 100)
    }
  },
  created() {
    console.log("created")
  },
  computed: {
    reset(){
      return this.$store.getters.getReset
    },
    
    progressAnimation() {
      const width = (this.conIndex / this.progressMax) * 100;
      return {
        width: width + "%"
      };
    },
    isMaxReached() {
      return this.conIndex >= this.progressMax || this.possCount <= maxResults ||!this.fieldSelected;
    },
    fieldSelected(){
      return this.gName || this.fName || this.country || this.age || this.gender || this.ship || this.trade || this.year || this.crime
    }
  },
  methods: {
    
    showConvict(conIndex) {

      this.$store.commit("setPossibleConvicts",this.possCons)
      this.$store.commit("setPossibleIndex",conIndex)    
      this.$router.push("/convict-entry")
    },
    showRandomConvict(conIndex) {
      this.$store.commit("setPossibleConvicts",this.randomCons)
      this.$store.commit("setPossibleIndex",conIndex)
      console.log("CLEAR CONS")
      this.randomCons=[]
      this.$router.push("/found")
    },
    
    randomConvict(){
      let activeFields=[]
      console.log("allFields",this.allFields)
      for(var f in this.allFields){
        if(this[this.allFields[f]]){
          activeFields.push(this.allFields[f])
        }
        this.$store.commit("setSearchFields",activeFields)
        console.log(this[this.allFields[f]])
      }
      
      console.log("RANDOMX",this.conIndex,this.allNames.length,this.possCons.length)
      // Choose appropriate base set for random selection
      let base
      const isGenderOnly = !!this.gender && !this.gName && !this.fName && !this.country && !this.age && !this.trade && !this.crime && !this.ship && !this.year
      if (!this.fieldSelected) {
        base = this.allNames
      } else if (isGenderOnly && this.possCons.length === 0) {
        // Use gender bucket if only gender selected and progressive list is empty
        if (this.gender === 'Male') base = this.maleCons
        else if (this.gender === 'Female') base = this.femaleCons
        else base = this.unknownCons
      } else if (this.possCons.length > 0) {
        base = this.possCons
      } else {
        base = this.allNames
      }
      this.randomCons = []
      const limit = Math.min(this.maxCons, base.length || 0)
      for (let i = 0; i < limit; i++) {
        this.randomCons.push(base[Math.floor(Math.random() * base.length)])
      }
      this.showRandomConvict(Math.floor(Math.random()*this.randomCons.length))
    },
    
    waitForOptions(){
      if(!this.optionsShown){
       setTimeout(this.processName,100)
       this.overlayText="Filtering Data..."
      }else{
        setTimeout(this.waitForOptions,100)
        this.overlayText="Sorting Data Full..."
      }
    },
    
    setAllCrimes(){
      if(this.crimesAllC){
       this.crimesC=this.crimesAllC.concat([])
      }else{
        let length = this.allNames.length, result = [], seen = new Set();
        outerCR:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].cr;
          if (seen.has(value)) continue outerCR;
          seen.add(value);
          result.push(value);
        }
        this.crimesC =Array.from(seen).sort()
      }
        this.overlayText="Sorting Ships..."
        this.conIndex = 70000;
        setTimeout(this.setAllShips,10)
    },
    setAllGNames(){
      if(this.givenNamesAll || this.givenNamesAllC){
       if (this.givenNamesAll) this.givenNames=this.givenNamesAll.concat([])
       if (this.givenNamesAllC) this.givenNamesC=this.givenNamesAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
     
        outerG:  

        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].g;
          if (seen.has(value)) continue outerG;
          seen.add(value);
          result.push(value);

        }
        this.givenNames=Array.from(seen).sort()
        
      }
        this.overlayText="Sorting Family Names..."
        this.conIndex = 40000;
        setTimeout(this.setAllFNames,10)
    },
    setAllFNames(){
      if(this.familyNameAll || this.familyNameAllC){
       if (this.familyNameAll) this.familyName=this.familyNameAll.concat([])
       if (this.familyNameAllC) this.familyNameC=this.familyNameAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
      outerF:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].f;
          if (seen.has(value)) continue outerF;
          seen.add(value);
          result.push(value);
        }
        
        this.familyName=Array.from(seen).sort()
      }
      this.overlayText="Sorting Countries..."
        this.conIndex = 45000;
        setTimeout(this.setAllCountries,10)
    },
    setAllCountries(){
      if(this.countriesAll || this.countriesAllC){
       if (this.countriesAll) this.countries=this.countriesAll.concat([])
       if (this.countriesAllC) this.countriesC=this.countriesAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        outerC:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].c;
          if (seen.has(value)) continue outerC;
          seen.add(value);
          result.push(value);
        }
        this.countries =Array.from(seen).sort()
      }
        this.overlayText="Sorting Genders..."
        this.conIndex = 50000;
        setTimeout(this.setAllGenders,10)
    },
    setAllAges(){
      if(this.agesAll || this.agesAllC){
       if (this.agesAll) this.ages=this.agesAll.concat([])
       if (this.agesAllC) this.agesC=this.agesAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        
        outerA:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].a;
          if (seen.has(value)) continue outerA;
          seen.add(value);
          result.push(value);
        }
        this.ages  =Array.from(seen).sort()
      }
        this.overlayText="Sorting Trades..."
        this.conIndex = 60000;
        setTimeout(this.setAllTrades,10)
    },
    setAllGenders(){
      if(this.gendersAll || this.gendersAllC){
       if (this.gendersAll) this.genders=this.gendersAll.concat([])
       if (this.gendersAllC) this.gendersC=this.gendersAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        outerS:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].s;
          if (seen.has(value)) continue outerS;
          seen.add(value);
          result.push(value);
        }
        this.genders =Array.from(seen).sort()
      }
        this.overlayText="Sorting Ages..."
        this.conIndex = 55000;
        setTimeout(this.setAllAges,10)
    },
    setAllShips(){
      if(this.shipsAllC){
       this.shipsC=this.shipsAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        
        outerSH:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].sh;
          if (seen.has(value)) continue outerSH;
          seen.add(value);
          result.push(value);
        }
        this.shipsC =Array.from(seen).sort()
      }
        this.overlayText="Sorting Arrival Years..."
        this.conIndex = 75000;
        setTimeout(this.setAllYears,10)
    },
    setAllTrades(){
      if(this.tradesAllC){
       this.tradesC=this.tradesAllC.concat([])
      }else{
        let length = this.allNames.length, result = [], seen = new Set();
        outerT:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].t;
          if (seen.has(value)) continue outerT;
            seen.add(value);
            result.push(value);
          }
          this.tradesC =Array.from(seen).sort()
      }
      this.overlayText="Sorting Crimes..."
      this.conIndex = 65000;
      setTimeout(this.setAllCrimes,10)
    },
    setAllYears(){
      if(this.yearsAll || this.yearsAllC){
       if (this.yearsAll) this.years=this.yearsAll.concat([])
       if (this.yearsAllC) this.yearsC=this.yearsAllC.concat([])
      }else{
      let length = this.allNames.length
      let result = []
      let seen = new Set();

        outerYA:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].ya;
          if (seen.has(value)) continue outerYA;
          seen.add(value);
          result.push(value);
        }
        this.years =Array.from(seen).sort()
      }
        //this.overlayText="Done"
        this.overlayState="hidden"
       // this.possCount=length
    },

    
    clearReset(){
      console.log("CLEAR RESET FROM SEARCH")
      this.$store.commit("setReset",false)
      //setTimeout(this.setUpData,100)
    }
    
  },
  watch:{
    reset(val){
      if(val){
        this.resetData()
        console.log("DO RESET FROM SEARCH")
        setTimeout(this.clearReset,500)
      }
     
    },
  }
};
</script>

<style>
.searchPanel {
  position: relative;
  height:90px;
}
.searchOverlay {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  background-color: var(--transparent-charcoal);
  z-index: 2000;
      height: 100vh;
    
    position: fixed;
}
.refine-search {
  color: var(--brick);
  padding: 1.5em 0 1.25em;
  margin: 0;
  margin-bottom: 1.1em;
  border-top: 1px solid var(--brick);
  border-bottom: 1px solid var(--brick);
}
.progress-container {
  display: flex;
  justify-content: center;
}
.progress-bar {
  width: 13em;
  height: 0.5em;
  background-color: var(--brick);
  border-radius: 1em;
  margin: 0.25em 0 0.5em;
}
.progress-bar-filling {
  width: 0%;
  height: 0.5em;
  background-color: var(--warm-sandstone);
  border-radius: 1em;
}
.nameSearch{
   display: flex; 
   padding: 0 3em;
}
  @media (max-width: 500px) {
    .nameSearch{
   display: flex; 
   padding: 0 0em;
}
.searchResults {
  display: flex;
    justify-content: center;
    position: fixed;
    width: 100%;
    bottom: 63px;
  }
}
</style>
